import ceil from 'lodash/ceil';
import moment from 'moment';
import { parseFeedMQTT } from './gtfsRtParser';

const standardModes = ['bus', 'tram', 'ferry'];
//5t, elenco dei 271 trams
const trams = ['116','201','312','427','447','502','2592','2595','2598','2802','2807','2815','2816','2817','2819','2823','2828','2833','2834','2835','2836','2837','2838','2839','2841','2842','2843','2844','2845','2847','2848','2850','2851','2852','2853','2854','2855','2856','2857','2858','2859','2860','2862','2863','2865','2867','2868','2869','2870','2871','2872','2873','2874','2875','2877','2878','2879','2880','2881','2882','2883','2885','2886','2887','2888','2889','2890','2891','2892','2893','2894','2895','2896','2897','2898','2899','2900','2901','2902','3104','3179','3203','3279','3501','5000','5001','5002','5003','5004','5005','5006','5007','5008','5009','5010','5011','5012','5013','5014','5015','5016','5017','5018','5019','5020','5022','5023','5024','5025','5026','5027','5028','5029','5030','5031','5032','5033','5034','5035','5036','5037','5038','5039','5040','5041','5042','5043','5044','5045','5046','5047','5048','5049','5050','5051','5052','5053','6000','6001','6002','6003','6004','6005','6006','6006','6007','6007','6008','6008','6009','6009','6010','6010','6011','6011','6012','6012','6013','6013','6014','6014','6015','6015','6016','6016','6017','6017','6018','6018','6019','6019','6020','6020','6021','6021','6022','6022','6023','6023','6024','6024','6025','6025','6026','6026','6027','6027','6028','6028','6029','6029','6030','6030','6031','6031','6032','6032','6033','6033','6034','6034','6035','6035','6036','6036','6037','6037','6038','6038','6039','6039','6040','6040','6041','6041','6042','6042','6043','6043','6044','6044','6045','6045','6046','6046','6047','6047','6048','6048','6049','6049','6050','6050','6051','6051','6052','6052','6053','6053','6054','6054','8001','8002','8003','8004','8005','8006','8007','8008','8009','8010','8011','8012','8013','8014','8015','8016','8017','8018','8019','8020','8021','8022','8050','8053','8060','8061','8062','8067','8068','27590']

const getMode = mode => {
  if (standardModes.includes(mode)) {
    return mode;
  }
  if (mode === 'train') {
    return 'rail';
  }
  if (mode === 'metro') {
    return 'subway';
  }
  // bus mode should be used as fallback if mode is not one of the standard modes
  return 'bus';
};

// getTopic
// Returns a MQTT topic to be subscribed to
// Input: options - route, direction, tripStartTime are used to generate the topic
function getTopic(options, settings) {
  // console.log('5t getTopic options', options, 'settings ', settings)
  const route = options.route ? options.gtfsId.replace(/gtt\:/, '').replace(/U$/,'') : '+'; // torno alla linea semplice es 16CS !!
  // const direction = options.direction
  //   ? parseInt(options.direction, 10) + 1
  //   : '+';
  // const geoHash = options.geoHash ? options.geoHash : ['+', '+', '+', '+'];
  // const tripId = options.tripId ? options.tripId : '+';
  // const headsign = options.headsign ? options.headsign : '+';
  // const tripStartTime = options.tripStartTime ? options.tripStartTime : '+';
  // const topic = settings.mqttTopicResolver(
  //   route,
  //   direction,
  //   tripStartTime,
  //   headsign,
  //   settings.agency,
  //   tripId,
  //   geoHash,
  //   );
  //   return topic;

    // 5t return `/hfp/v1/journey/ongoing/+/+/+/${route}/${direction}/+/${tripStartTime}/#`;
    // 5t al 19/04/2020 il topic è stato semplificato ed è così strutturato:
    // 5t /bt/matricola/linea/direzione/fermata
    // return `/+/+/${route}/${direction}/+/${tripStartTime}/#`;
    return `/${route}/#`;
}
// ad oggi, 21/2/2020 topic = "/tram/6002/10/1/DEST/1081/392/45;7/06/66/01",
export function parseMessage(topic, message, agency) {
  let parsedMessage;
  const [
    ,
    // mode,
    line,
    id, // matricola del mezzo, arriva anche nel message come veh...
    // dir,(spostato nel messaggio)
    // headsign, // eslint-disable-line no-unused-vars
    // nextStop, // è quello usato per posizionare il mezzo nella vista linearizzata es gtt:1680 (spostato nel messaggio)
    // startTime,
    ...rest // eslint-disable-line no-unused-vars
  ] = topic.split('/');

  // 5t const vehid = `${agency}_${id}`;
  const vehid = `${id}`;

  // 5t empty message: delete vehicle
  if (message instanceof Uint8Array) { // mqtt
    // parsedMessage = JSON.parse(message); // .VP;
    if(message.length === 0){
      // TODO cancellare il relativo pallozzo
      // console.log('messaggio di delete', line, id)
    } else {

      let compat;
      try{
        compat = JSON.parse(message)
        parsedMessage = {
          lat:    compat[0],
          long:   compat[1],
          hdg:    compat[2],
          spd:    compat[3],
          tripId: compat[4],
          dir:    compat[5],
          nextStop: `gtt:${compat[6]}`,  //riaggiungo prefisso gtt: strippato lato server
          full:   compat[7],  // =0 vuoto. =1 pieno
        }
      } catch(err){
        console.log('ERRORE PARSE JSON del message:', message)
        console.log(err)
      }
    }
  } else {
    // 5t parsedMessage = message.VP;  //json via rest
    parsedMessage = message;
  }
  // console.log('startTime',startTime !== 'undefined' ? startTime : undefined )
// console.log('parsedMessage', parsedMessage)

  if (parsedMessage && parsedMessage.full === '1') { console.log('mezzo pieno', line, id)}

  if (
    parsedMessage &&
    parsedMessage.lat &&
    parsedMessage.long &&
    (parsedMessage.seq === undefined || parsedMessage.seq === 1) // seq is used for hsl metro carriage sequence
  ) {

    return {
      id: vehid,
      // 5t route: `${agency}:${line}`,
      // route: `${agency}:${line}U`, // in gtfs le linee gtt hanno suffisso U E
      route: `gtt:${line}U`, // in otp le le linee hanno prefisso feedId e suffisso U E,
      // 5t direction: parseInt(dir, 10) - 1,
      direction: parseInt(parsedMessage.dir, 10),
      // tripStartTime: startTime !== 'undefined' ? startTime : undefined,  // deciso di non trasmetterlo più
      tripStartTime: undefined,
      // 5t operatingDay:
      //   parsedMessage.oday && parsedMessage.oday !== 'XXX'
      //     ? parsedMessage.oday
      //     : moment().format('YYYY-MM-DD'),
      operatingDay:  parsedMessage.oday ? parsedMessage.oday : moment().format('YYYYMMDD'),
      // 5t mode: modeTranslate[mode] ? modeTranslate[mode] : mode,
      // mode: id > 5000 ? 'tram' :'bus', // non lo mando più, lo desumo dalla matricola
      mode: trams.includes(id) ? 'tram' :'bus', // troppi mezzi nuovi, devo controllare matricola per matricola
      next_stop: parsedMessage.nextStop,
      timestamp: moment().unix(), //parsedMessage.tsi, // assumo che la posizione sia generata nel momento della ricezione
      lat: parsedMessage.lat && ceil(parsedMessage.lat, 5),
      long: parsedMessage.long && ceil(parsedMessage.long, 5),
      heading: parsedMessage.hdg, // 0: nord, orario
      headsign: undefined, // in HSL data headsign from realtime data does not always match gtfs data
      tripId: parsedMessage.tripId ? `${agency}:${parsedMessage.tripId}U` : null, // 5t da noi il tripId (se arriva)arriva già dal feed mqtt, non need for FuzzyTrip... // in gtfs le trip gtt hanno suffisso U E
      speed: parsedMessage.spd,
      shortName: parsedMessage.shortName, // se presente, è usato nel pallozzo come nome linea
      full: parsedMessage.full, //
    };
  }
  return undefined;
}

export function changeTopics(settings, actionContext) {
  const { client, oldTopics } = settings;

  if (Array.isArray(oldTopics) && oldTopics.length > 0) {
    client.unsubscribe(oldTopics);
  }
  const topics = settings.options.map(option => getTopic(option, settings));
  // console.log('****settings.options', settings.options); // 5t
  console.log('topic changed', topics); // 5t
  // set new topic to store
  actionContext.dispatch('RealTimeClientNewTopics', topics);
  client.subscribe(topics);
}

export function startMqttClient(settings, actionContext) {
  const options = settings.options || [{}];
  const topics = options.map(option => getTopic(option, settings));
  const mode = options.length && options[0].mode ? options[0].mode : 'bus';

  return import(/* webpackChunkName: "mqtt" */ 'mqtt').then(mqtt => {
    // SE GTFSRT
    if (settings.gtfsrt) {
      return import(/* webpackChunkName: "gtfsrt" */ './gtfsrt').then(
        bindings => {
          const feedReader = bindings.FeedMessage.read;
          const credentials =
            settings.credentials !== undefined ? settings.credentials : {};
          const client = mqtt.default.connect(settings.mqtt, credentials);
          client.on('connect', () => client.subscribe(topics));
          // console.log('subscribed with topic', topics); // 5t

          client.on('message', (topic, messages) => {
            const parsedMessages = parseFeedMQTT(
              feedReader,
              messages,
              topic,
              settings.agency,
              mode,
            );
            parsedMessages.forEach(message => {
              actionContext.dispatch('RealTimeClientMessage', message);
            });
          });

          return { client, topics };
        },
      );
    }
    // SE MQTT
    const client = mqtt.default.connect(settings.mqtt);
    // console.log('subscribed with topic', topics); // 5t
    client.on('connect', () => client.subscribe(topics));
    client.on('message', (topic, message) =>
      actionContext.dispatch(
        'RealTimeClientMessage',
        parseMessage(topic, message, settings.agency),
      ),
    );
    return { client, topics };
  });
}
